<template>
  <b-modal
    ref="modal"
    :visible="visible"
    @hidden="onHidden"
    id="kick-confirm-modal"
    centered
    hide-header
    hide-footer
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    body-class="p-0"
    content-class="kick-confirm-modal-content"
  >
    <div class="modal-body-content">
      <h4 class="modal-title">Kullanıcıyı At</h4>
      <p v-if="participant" class="modal-text">
        <strong>{{ participant.name }}</strong> kullanıcısını yayından atmak istediğinize emin misiniz?
      </p>
      <p v-else class="modal-text">
        Katılımcı bilgisi yükleniyor...
      </p>
      <div class="modal-actions">
         <b-button variant="danger" class="confirm-button" @click="handleConfirm" :disabled="!participant">
          Onayla
        </b-button>
        <b-button variant="secondary" class="cancel-button" @click="hideModal">
          İptal
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { BModal, BButton } from 'bootstrap-vue'

export default {
  name: 'KickConfirmationModal',
  components: {
    BModal,
    BButton,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    participant: { // Expecting an object { id: ..., name: ... }
      type: Object,
      default: null,
    },
  },
  methods: {
    handleConfirm() {
      if (this.participant && this.participant.id) {
        this.$emit('confirm', this.participant.id);
        // Optionally hide modal immediately after confirm
        // this.hideModal(); 
      }
    },
    hideModal() {
      if (this.$refs.modal) {
        this.$refs.modal.hide();
      }
    },
    onHidden() {
      // Notify parent to update visibility state
      this.$emit('update:visible', false);
    },
  },
}
</script>

<style lang="scss" scoped>
.kick-confirm-modal-content {
  border-radius: 16px !important;
  border: none;
}

.modal-body-content {
  padding: 30px;
  text-align: center;
  background-color: #ffffff;
  border-radius: 16px;
  color: #333;
}

.modal-title {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 15px;
  color: #000;
}

.modal-text {
  font-size: 16px;
  margin-bottom: 25px;
  color: #555;
}

.modal-actions {
  display: flex;
  justify-content: center;
  gap: 15px;

  .confirm-button,
  .cancel-button {
    font-weight: 600;
    padding: 12px 30px;
    border-radius: 25px;
    flex-grow: 1; 
    max-width: 180px;
    transition: background-color 0.2s ease, border-color 0.2s ease;
  }

  .confirm-button {
      background-color: #FF3B30 !important; 
      border-color: #FF3B30 !important;
      color: white;
      &:hover {
         background-color: #e02a21 !important; 
         border-color: #e02a21 !important;
      }
       &:disabled {
       background-color: #cccccc !important;
       border-color: #cccccc !important;
    }
  }

  .cancel-button {
      background-color: #e0e0e0 !important; 
      border-color: #e0e0e0 !important;
      color: #757575;
        &:hover {
            background-color: #d1d1d1 !important;
            border-color: #d1d1d1 !important;
        }
         &:disabled {
            background-color: #cccccc !important;
            border-color: #cccccc !important;
             color: #a0a0a0;
        }
  }
}


</style> 